import * as z from 'zod';

const PreviousMeetingsSchema = z.object({
  homeWins: z.number(),
  draws: z.number(),
  awayWins: z.number(),
});

export default PreviousMeetingsSchema;
